export default {
  colors: [
    //"#a3be8c",
    //"#b48ead",
    //"#ebcb8b",
    //"#d08770",
    //"#bf616a",
    //"#8fbcbb",
    //"#88c0d0",
    //"#81a1c1",
    //"#5e81ac"
    "#005a85",
    "#0391af",
    "#40c1dc",
    "#9d0c4a",
    "#ad4594",
    "#e353aa",
    "#d62b03",
    "#f06914",
    "#f0b414"
  ],
  lang: {
    decimalPoint: ","
  },
  chart: {
    backgroundColor: "transparent",
    borderWidth: 0,
    height: "90%",
    borderRadius: 15,
    plotBackgroundColor: null,
    plotShadow: false,
    marginRight: 50,
    plotBorderWidth: 0,
    style: {
      font:
        "16px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
    }
  },
  title: {
    style: {
      color: "#000000",
      font:
        "16px Galano, Roboto Black, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
    }
  },
  subtitle: {
    style: {
      color: "#2E3440",
      font:
        "12px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif",
      fontWeight: "light"
    }
  },
  xAxis: {
    gridLineWidth: 0,
    lineColor: "rgba(46, 52, 64, .1)",
    tickColor: "rgba(46, 52, 64, .1)",
    labels: {
      reserveSpace: true,

      style: {
        color: "#2e3440",
        fontWeight: "normal"
      }
    },
    title: {
      style: {
        color: "#000000",
        font:
          "normal 12px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
      }
    }
  },
  yAxis: {
    alternateGridColor: null,
    minorTickInterval: null,
    gridLineColor: "rgba(46, 52, 64, .1)",
    lineWidth: 0,
    tickWidth: 0,
    labels: {
      align: "left",
      reserveSpace: true,
      style: {
        color: "#2e3440",
        fontWeight: "normal",
        font:
          "light 12px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
      }
    },
    title: {
      style: {
        color: "#000000",
        font:
          "normal 12px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
      }
    }
  },
  legend: {
    itemStyle: {
      color: "#000000",
      fontWeight: "normal"
    },
    itemHoverStyle: {
      color: "#999999"
    },
    itemHiddenStyle: {
      color: "#333333"
    }
  },
  credits: {
    enabled: false,
    text:
      "© Copyright 2020 www.digital-report.de: Alle Inhalte sind urheberrechtlich geschützt."
  },
  labels: {
    style: {
      color: "#999999",
      font:
        "normal 12px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
    }
  },
  tooltip: {
    backgroundColor: "#eceff4",
    borderWidth: 0,
    style: {
      color: "#000"
    }
  },
  plotOptions: {
    packedbubble: {
      dataLabels: {
        enabled: true,
        format: "{point.name}: {point.value}",
        style: {
          color: "#999999",
          textOutline: "none",
          font:
            "normal 12px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
        }
      }
    },
    line: {
      dataLabels: {
        color: "#cccccc"
      },
      marker: {
        lineColor: "#333333"
      }
    },
    spline: {
      marker: {
        lineColor: "#333333"
      }
    },
    scatter: {
      marker: {
        lineColor: "#333333"
      }
    }
  },
  toolbar: {
    itemStyle: {
      color: "#cccccc"
    }
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 500
        },

        chartOptions: {
          chart: {
            height: "100%",
            style: {
              font:
                "12px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
            }
          },
          title: {
            style: {
              font:
                "12px Galano, Roboto Black, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
            }
          },
          subtitle: {
            subtitle: {
              text: "Wählen Sie ein Gebiet aus um zu Zoomen",
              style: {
                color: "#2E3440",
                font:
                  "8px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif",
                fontWeight: "light"
              }
            }
          },
          xAxis: {
            labels: {
              style: {
                font:
                  "6px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
              }
            }
          },
          labels: {
            style: {
              color: "#999999",
              font:
                "normal 6px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
            }
          },
          yAxis: {
            labels: {
              style: {
                font:
                  "6px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
              }
            }
          }
        }
      }
    ]
  }
};
